
import { Vue } from 'vue-class-component';

export default class InlineQuestion extends Vue {}
